import { cn } from '../../../lib/utils';
import type { RepescagemLead, RepescagemStage, StageConfig } from './types';
import { RepescagemCard } from './RepescagemCard';

interface RepescagemKanbanColumnProps {
  stage: RepescagemStage;
  config: StageConfig;
  leads: RepescagemLead[];
  count: number;
  onCardClick: (lead: RepescagemLead) => void;
}

export function RepescagemKanbanColumn({
  stage,
  config,
  leads,
  count,
  onCardClick,
}: RepescagemKanbanColumnProps) {
  return (
    <div className="flex flex-col min-w-[240px] max-w-[280px] flex-1 rounded-lg border bg-muted/30">
      {/* Column header */}
      <div
        className={cn(
          'flex items-center justify-between px-3 py-2.5 border-b border-t-4 rounded-t-lg',
          config.headerColor
        )}
      >
        <span className="text-sm font-semibold text-foreground">{config.label}</span>
        <span
          className={cn(
            'inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-full text-xs font-bold border',
            config.color
          )}
        >
          {count}
        </span>
      </div>

      {/* Cards list */}
      <div className="flex-1 overflow-y-auto p-2 space-y-2 min-h-[120px] max-h-[calc(100vh-230px)]">
        {leads.length === 0 ? (
          <div className="flex items-center justify-center h-16 text-xs text-muted-foreground">
            Nenhum lead
          </div>
        ) : (
          leads.map((lead) => (
            <RepescagemCard key={lead.id} lead={lead} onClick={onCardClick} />
          ))
        )}

        {/* Show count discrepancy if server count > loaded */}
        {count > leads.length && (
          <p className="text-center text-xs text-muted-foreground py-1">
            +{count - leads.length} não exibido(s)
          </p>
        )}
      </div>
    </div>
  );
}
